import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Utente } from '../../models/utente';

export interface Informativa {
  id: string;
  testo: string;
  link: string;
}

/**
 * Il servizio per la gestione del consenso privacy
 */
@Injectable( { providedIn: 'root' })
export class ConsensoService {
  private informativa: Informativa;
  private consensoDato = false;
  optionsContJson = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(public http: HttpClient) {
    console.log('Hello ConsensoService Provider');
  }

  cercaConsenso(utente: Utente): Observable<any> {
    console.log('consenso dato ' + this.consensoDato);
    if (this.consensoDato) {
      return of(true);
    } else {
      return this.http.get('consenso/utente/' + utente.id).pipe(
        map(r => {
          this.consensoDato = true;
          console.log('consenso trovato');
          return of(true);
        }),
        catchError(error => {
          return of(false);
        })
      );
    }
  }

  getInformativa(): Observable<Informativa> {
    if (this.informativa) {
      return of(this.informativa);
    } else {
      return this.http.get<Informativa>(`consenso/informativa`)
        .pipe(map(r => this.parseInformativa(r)));
    }
  }

  private parseInformativa(response: any): Informativa {
    const json = response;
    if (json) {
      this.informativa = json;
      return this.informativa;
    } else {
      throw response;
    }
  }

  inviaConsenso(utente: Utente): Observable<any> {
    const p: any = {
      idUtente: utente.id,
      idInformativa: this.informativa.id
    };

    return this.http
      .put('consenso', JSON.stringify(p), this.optionsContJson)
      .pipe(
        map(r => {
          if (r) {
            this.consensoDato = true;
          }
        })
      );
  }
}
